// ABOUTME: Accent colour per integration, shared by the admin flow grid, chips, and filters
export const INTEGRATION_COLORS: Record<string, string> = {
  AMOS: '#10b981',
  LEON: '#ef4444',
  FL3XX: '#8b5cf6',
  TECHLOG: '#3b82f6',
  RAAS: '#f59e0b',
  RUSADA: '#06b6d4',
  TRAXXALL: '#ec4899',
  ASTRO: '#6366f1',
  BLUEONE: '#14b8a6',
  CAMP: '#f97316',
  NAVBLUE: '#0ea5e9',
};
